module.exports = __webpack_public_path__ + "img/lookbook_11_left.b3a42724.png";